import React, { useState } from "react";
import Logo from "../common/mobile/Logo";


const Footer = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const origin = window.location.origin.replace(/^https?:\/\/(www\.)?/, '').replace(/(\.com|\.live|\.net)$/i, '');



  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  return (
    <div className="footer-wrap">
      <div className="footer-1200">
        <div className="description">
        <div
             className={`description-section ${isExpanded ? '' : 'fold'}`}
            
            style={{
              height: isExpanded ? "auto" : "970px"
            }}
          >
            <div className="description-container" id="footerSeoContent">
              <div className="title">
                <span className="title-text">
                  {origin} বাংলাদেশ সরকার কর্তৃক অনুমোদিত — অনলাইন গেমিং ও স্পোর্টস বেটিংয়ের সেরা গন্তব্য
                </span>
              </div>
              <div className="main-landing-page-content">
                <span>
                  <p>
                    {origin}-এ স্বাগতম! {origin} বাংলাদেশের অন্যতম জনপ্রিয়, নির্ভরযোগ্য ও নিরাপদ অনলাইন গেমিং এবং স্পোর্টস বেটিং প্ল্যাটফর্ম। এখানে একই জায়গায় পাবেন ক্যাসিনো গেম, স্লট, ক্র্যাশ গেম, লাইভ ক্যাসিনো, স্পোর্টস বেটিং এবং আধুনিক বেটিং এক্সচেঞ্জ — সবকিছু এক ছাদের নিচে। আমাদের লক্ষ্য হলো বাংলাদেশের প্রতিটি খেলোয়াড়ের জন্য সেরা ও আনন্দময় গেমিং অভিজ্ঞতা তৈরি করা।
                  </p>
                  <p>
                    <strong>বিশ্বমানের গেমিং অপশন</strong><br />
                    {origin}-এ আপনি পাচ্ছেন I-Sports, JDB, CQ9, Pocket Games, Evolution সহ বিশ্বের নামকরা গেম প্রোভাইডারদের বিশাল কালেকশন। হাই-অকটেন স্লট, ক্লাসিক টেবিল গেম কিংবা ইমার্সিভ লাইভ ডিলার গেম — প্রত্যেক ধরনের খেলোয়াড়ের জন্য রয়েছে কিছু না কিছু।
                  </p>
                  <p>
                    লাইভ ক্যাসিনোর রোমাঞ্চ পেতে Sexy এবং Evolution নিয়ে এসেছে বাস্তব ক্যাসিনোর অভিজ্ঞতা সরাসরি আপনার স্ক্রিনে — পেশাদার ডিলার এবং রিয়েল-টাইম গেমপ্লে সহ। আর পোকারের কৌশলগত চ্যালেঞ্জ ভালোবাসলে BPOKER-এ পাবেন দেশ-বিদেশের খেলোয়াড়দের সঙ্গে খেলার অসংখ্য টেবিল ও টুর্নামেন্ট।
                  </p>
                  <p>
                    <strong>আধুনিক বেটিং এক্সচেঞ্জ</strong><br />
                    {origin} শুধু ক্যাসিনো নয় — সরাসরি অন্য খেলোয়াড়ের বিপক্ষে বাজি ধরার উত্তেজনাপূর্ণ বেটিং এক্সচেঞ্জও রয়েছে। এতে আপনার বাজির ওপর বেশি নিয়ন্ত্রণ থাকে এবং প্রচলিত প্ল্যাটফর্মের তুলনায় প্রায়ই ভালো অডস পাওয়া যায়। ক্রিকেট, ফুটবল কিংবা ঘোড়দৌড় — যেকোনো ইভেন্টে এক্সচেঞ্জে স্মার্ট ও তথ্যভিত্তিক বাজি ধরুন।
                  </p>
                  <p>
                    আমাদের স্পোর্টস বেটিং পরিচালিত হয় JB Sports, Horsebook এবং E1SPORT-এর মতো শীর্ষ প্রোভাইডারদের মাধ্যমে, যাতে সবসময় সর্বশেষ অডস ও বিস্তৃত বেটিং মার্কেট পান। প্রি-ম্যাচ থেকে লাইভ ইন-প্লে বেটিং — আমরা কভার করি সব প্রধান খেলা ও ইভেন্ট।
                  </p>
                  <p>
                    <strong>বৈচিত্র্যময় গেম কালেকশন</strong><br />
                    {origin} বাংলাদেশে রয়েছে প্রতিটি খেলোয়াড়ের পছন্দের গেম। Joker, KA, RT, SG, JILI-সহ শীর্ষ প্রোভাইডারদের সহযোগিতায় স্লট গেমের বিশাল সম্ভার — বিশাল জ্যাকপটের হাই-ভোলাটিলিটি গেম থেকে শুরু করে ক্যাজুয়াল লো-রিস্ক গেম পর্যন্ত। প্রতিটি গেমে রয়েছে আধুনিক গ্রাফিক্স, ইনোভেটিভ ফিচার ও আকর্ষণীয় থিম।
                  </p>
                  <p>
                    নতুন কিছু খুঁজছেন? SPRIBE, Yellow Bat, HotRoad ও FASTSPIN-এর মতো প্রোভাইডারদের নিশ গেমগুলোতে পাবেন অনন্য গেমপ্লে মেকানিক্স ও তাজা কনটেন্ট, যা সাধারণ ক্যাসিনো গেম থেকে আলাদা।
                  </p>
                  <p>
                    <strong>বোনাস ও প্রমোশনে সর্বোচ্চ জেতার সুযোগ</strong><br />
                    {origin}-এ আমরা খেলোয়াড়দের রিওয়ার্ড করতে বিশ্বাস করি। নতুন খেলোয়াড়দের জন্য জেনারাস ওয়েলকাম বোনাস, আর নিয়মিত খেলোয়াড়দের জন্য ডিপোজিট ম্যাচ, ফ্রি স্পিন এবং ক্যাশব্যাকসহ চলমান প্রমোশন — যা আপনার জেতার সম্ভাবনা আরও বাড়িয়ে দেয়।
                  </p>
                  <p>
                    আমাদের রেফারেল প্রোগ্রামেও পাবেন বাড়তি রিওয়ার্ড। বন্ধুদের {origin}-এ যোগ দিতে আমন্ত্রণ জানান; প্রতিটি বন্ধু সাইন আপ ও ডিপোজিট করলে পাবেন বোনাস ক্রেডিট, যা ব্যবহার করতে পারবেন আমাদের বিশাল গেম লাইব্রেরিতে। এতে আপনার জেতার সম্ভাবনাও বাড়ে, সাথে বন্ধুদের সঙ্গে আনন্দ ভাগাভাগি হয়।
                  </p>
                  <p>
                    <strong>নিরাপদে ও আত্মবিশ্বাসের সাথে খেলুন</strong><br />
                    {origin}-এ আপনার নিরাপত্তাই আমাদের প্রথম অগ্রাধিকার। PT, WorldMatch, NETENT ও PNG-র মতো স্বনামধন্য প্রোভাইডারদের সঙ্গে কাজ করে আমরা নিশ্চিত করি সব গেম ন্যায্য এবং আপনার ব্যক্তিগত তথ্য সুরক্ষিত। অত্যাধুনিক এনক্রিপশন প্রযুক্তিতে আপনার ডেটা থাকে নিরাপদ — তাই নিশ্চিন্তে খেলুন।
                  </p>
                  <p>
                    <strong>{origin} বাংলাদেশ কমিউনিটিতে যোগ দিন</strong><br />
                    সেরা অনলাইন গেমিং ও বেটিং অভিজ্ঞতার জন্য আজই {origin} বাংলাদেশ কমিউনিটিতে যোগ দিন। ব্যবহারকারী-বান্ধব প্ল্যাটফর্মে সহজেই গেম লাইব্রেরি ঘুরে দেখুন, পছন্দের স্পোর্টসে বাজি ধরুন এবং আকর্ষণীয় প্রমোশন উপভোগ করুন। রেফারেল প্রোগ্রামে বন্ধুদের আমন্ত্রণ জানিয়ে বাড়তি রিওয়ার্ড অর্জন করুন। দায়িত্বশীলভাবে খেলুন, আনন্দ নিন — {origin}-এর সাথেই শুরু হোক আপনার গেমিং যাত্রা!
                  </p>
                  <p>
                    <small>১৮+ শুধুমাত্র। দায়িত্বশীলভাবে খেলুন। জুয়া ও বাজি আসক্তি স্বাস্থ্যের জন্য ক্ষতিকর হতে পারে।</small>
                  </p>
                </span>
              </div>
            </div>
          </div>
          <div
            className="show-more-btn btn-default"
            id="footerSeoToggleBtn"
            onClick={toggleExpand} // Toggle expand on click
          >
            {isExpanded ? "Show Less" : "Show More"} {/* Button text changes based on state */}
          </div>
        </div>

        <ul className="footer-link-group">
          {/* Footer Links */}
          <li>
            <div className="icon-wrap icon1"></div>
            <div className="text-wrap">
              <h4>Customer Support</h4>
              <h5>Available 24/7 to assist you</h5>
            </div>
          </li>
          <li>
            <div className="icon-wrap icon2"></div>
            <div className="text-wrap">
              <h4>New Member Guide</h4>
              <h5>Check out FAQ and guides</h5>
              <a href="https://{origin}help.com/">Explore Now</a>
            </div>
          </li>
          <li>
            <div className="icon-wrap icon3"></div>
            <div className="text-wrap">
              <h4>Brand Ambassador</h4>
              <h5>Play with celebrity</h5>
              <a href="#" data-pagetype="43">Have Fun Now</a>
            </div>
          </li>
          <li className="android-img">
            <a href="/page/site/component/appDownload.jsp" target="_blank">
              <img src="https://www.{origin}.com/images/web/footer/android-en.png" alt="Download for Android" />
            </a>
          </li>
        </ul>

        <ul className="footer-partner-wrap">
          {/* Responsible Gaming */}
          <li className="duty">
            <h5>Responsible Gaming</h5>
            <a href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer">
              <img src="https://www.{origin}.com/images/web/footer/color-white/safe1.png" alt="GamCare" />
            </a>
            <a href="https://{origin}help.com/account/18-policy/" target="_blank" rel="noopener noreferrer">
              <img src="https://www.{origin}.com/images/web/footer/color-white/safe2.png" alt="18+ Policy" />
            </a>
            <a href="https://{origin}help.com/responsible-gaming/" target="_blank" rel="noopener noreferrer">
              <img src="https://www.{origin}.com/images/web/footer/color-white/safe3.png" alt="Responsible Gaming" />
            </a>
          </li>
          
          {/* Payment Methods */}
          <li className="payment">
            <h5>Payment Methods</h5>
            {/* Add payment icons here */}
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay16.png" alt="Bank Deposit" /></a>
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay22.png" alt="bKash" /></a>
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay33.png" /></a>
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay34.png" /></a>
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay45.png" alt="UPAY" /></a>
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay59.png" alt="OKWallet" /></a>
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay60.png" alt="SureCash" /></a>
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay61.png" alt="tapPay" /></a>
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay47.png" alt="USDT" /></a>
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay91.png" alt="BTC" /></a>
          </li>

          {/* Social Media */}
          <li className="social-media">
            <h5>Community Websites</h5>
            <a href="https://cutt.ly/X8zvJCK" target="_blank" rel="noopener noreferrer">
              <img src="https://www.{origin}.com/images/web/footer/color-white/FaceBook.png" alt="Facebook" />
            </a>
            <a href="https://cutt.ly/F8zWryo" target="_blank" rel="noopener noreferrer">
              <img src="https://www.{origin}.com/images/web/footer/color-white/Instagram.png" alt="Instagram" />
            </a>
            <a href="https://cutt.ly/V8zQ3in" target="_blank" rel="noopener noreferrer">
              <img src="https://www.{origin}.com/images/web/footer/color-white/Twitter.png" alt="Twitter" />
            </a>
            <a href="https://cutt.ly/n8zWnUX" target="_blank" rel="noopener noreferrer">
              <img src="https://www.{origin}.com/images/web/footer/color-white/Pinterest.png" alt="Pinterest" />
            </a>
            <a href="https://cutt.ly/A8zWKKF" target="_blank" rel="noopener noreferrer">
              <img src="https://www.{origin}.com/images/web/footer/color-white/Youtube.png" alt="YouTube" />
            </a>
            <a href="https://cutt.ly/Dwkk45sZ" target="_blank" rel="noopener noreferrer">
              <img src="https://www.{origin}.com/images/web/footer/color-white/Telegram.png" alt="Telegram" />
            </a>
          </li>

          {/* Sponsorship and Ambassadors */}
          <li className="ft-spon">
            <h5>Sponsorships</h5>
            <div className="ft-spon__icon">
              <img className="spon-icon" src="https://www.{origin}.com/images/web/sponsor/delhi-bulls.png" alt="Delhi Bulls Sponsor" />
              <p>Delhi Bulls<br />2023 - 2024<span>Title Sponsor</span></p>
            </div>
          </li>
          
          <li className="ft-ambassador">
            <h5>Brand Ambassadors</h5>
            <ul className="header-btn-wrap">
              <li>
                <img src="https://www.{origin}.com/images/v1/web/jb/footer/ambassador_signature/andre-russell.png" alt="Andre Russell" />
                <a href="#" data-pagetype="43" data-active="andre-russell">
                  Andre Dwayne Russell<br />2024 - 2026
                </a>
              </li>
              <li>
                <img src="https://www.{origin}.com/images/v1/web/jb/footer/ambassador_signature/mcgrath.png" alt="Glenn McGrath" />
                <a href="#" data-pagetype="43" data-active="glenn-mcgrath">
                  Glenn McGrath<br />2023 - 2024
                </a>
              </li>
            </ul>
          </li>

          {/* Gaming License */}
          <li className="gaming-license">
            <h5>Gaming License</h5>
            <img src="https://www.{origin}.com/images/web/footer/gaming_license.png" alt="Gaming License" />
          </li>
        </ul>

        {/* Footer License and Logo */}
        <div className="footer-license">
          <div className="license-cont"></div>
        </div>
        
        <div className="footer-logo-wrap">
          <div className="footer-logo">
            <Logo/>
          </div>
          <div className="link-wrap">
            <ul>
              <li><a href="/" target="_blank" rel="noopener noreferrer">Affiliate</a></li>
              <li><a href="#" data-pagetype="25">Responsible Gaming</a></li>
              <li><a href="#" data-pagetype="21">About Us</a></li>
            </ul>
            <p>© 2024 {origin} Copyrights. All Rights Reserved</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;